import { styled } from '@material-ui/styles';
import { SPACING_SMALL } from '../../../constant/spacing';

export const List = styled('div')({
  position: 'relative',
  margin: SPACING_SMALL,
  flex: '1 0 160px',
  display: 'flex',
  flexDirection: 'column',
});

export const ScreenshotContainer = styled('div')({
  position: 'relative',
  border: '1px solid #ccc',
  overflow: 'visible',
  marginTop: SPACING_SMALL,
});

export const FitImage = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'contain',
});

export const CoverContainer = styled('div')({
  top: 0,
  width: '100%',
  height: '100%',
  position: 'absolute',
  overflow: 'hidden',
  zIndex: 1,
});

export const ErrorCover = styled('div')({
  width: '100%',
  height: '100%',
  paddingTop: '20%',
  backgroundColor: 'rgba(255,255,255,0.8)',
  textAlign: 'center',
});

export const InvalidCover = styled('div')({
  color: 'white',
  width: '100%',
  height: '100%',
  paddingTop: '20%',
  textAlign: 'center',
});

export const Skeleton = styled('div')({
  minHeight: '200px',
  width: '100%',
  height: '100%',
  backgroundColor: '#ccc',
  border: '1px solid #ccc',
  animation: '1.5s ease-in-out 0.5s infinite normal none running animation-skeleton',
});
